import { CartAddEvent, ThemeEvents } from '@theme/events';
import { matchLens } from './madam-lens-match.js';

class MadamProductLens extends HTMLElement {
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();
    if(this.closest('quick-add-dialog, product-card'))return;
    try{this.config=JSON.parse(this.querySelector('[data-lens-config]').textContent)}catch{return}
    this.selected=this.config.variant;
    const scope=this.closest('.shopify-section');
    const {signal}=this.controller;
    scope?.addEventListener(ThemeEvents.variantSelected,event=>{
      const picker=event.target.closest?.('variant-picker');
      if(picker?.dataset.productId===this.dataset.sourceProductId){this.hidden=true;this.current=null}
    },{signal});
    scope?.addEventListener(ThemeEvents.variantUpdate,event=>{
      if(event.detail?.data?.productId!==this.dataset.sourceProductId)return;
      this.selected=event.detail.resource;this.sync();
    },{signal});
    this.addEventListener('submit',event=>{if(!event.target.matches('[data-lens-form]'))return;event.preventDefault();event.stopPropagation();this.add()},{signal});
    this.sync();
  }
  disconnectedCallback(){this.controller?.abort()}
  sync(){
    this.current=matchLens(this.config,this.selected);
    this.hidden=!this.current;
    if(!this.current)return;
    const v=this.current;
    this.querySelector('[data-lens-id]').value=v.id;
    this.querySelector('[data-lens-price]').textContent=v.price;
    this.querySelector('[data-lens-pair]').textContent=v.options[this.config.lensModelIndex]+' · '+v.options[this.config.lensColorIndex];
    this.querySelectorAll('[data-lens-link]').forEach(a=>a.href=v.url);
    const image=this.querySelector('[data-lens-image]');
    image.hidden=!v.image;if(v.image)image.src=v.image;
    const button=this.querySelector('[data-lens-add]');button.disabled=!!this.adding;button.textContent=this.adding?'Ekleniyor…':'Lensi sepete ekle';
    this.querySelector('[data-lens-message]').textContent='';
  }
  async add(){
    if(this.adding||!this.current||this.hidden)return;
    const variant=this.current;
    this.adding=true;this.sync();
    const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))].slice(0,4);
    sections.push('madam-cart-offer');
    try{
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:variant.id,quantity:1}],sections,sections_url:window.location.pathname})
      });
      const data=await response.json();
      if(!response.ok||data.status)throw new Error(data.description||data.message||'Lens eklenemedi.');
      document.dispatchEvent(new CartAddEvent(data,'madam-product-lens',{source:'madam-product-lens',productId:this.dataset.sourceProductId,variantId:String(variant.id),sections:data.sections}));
      if(this.current?.id===variant.id)this.querySelector('[data-lens-message]').textContent='Lens sepetine eklendi.';
    }catch(error){
      this.querySelector('[data-lens-message]').textContent=error instanceof TypeError?'Bağlantı kesildi. Yeniden eklemeden önce sepetini kontrol et.':error.message;
    }finally{
      this.adding=false;const button=this.querySelector('[data-lens-add]');button.disabled=false;button.textContent='Lensi sepete ekle';
    }
  }
}
if(!customElements.get('mc-product-lens'))customElements.define('mc-product-lens',MadamProductLens);
